import { HttpInterceptors } from "./http.interceptor";

export class CustomerService extends HttpInterceptors {
	async listCustomer (filters) {
		const response = await this.axios.get("customer/listCustomer", { params: { filters }});
		return response.data;
	}

	async upsertCustomer (payload) {
		const response = await this.axios.post("customer/upsertCustomer", payload);
		return response.data;
	}

	async deleteCustomer (id) {
		const response = await this.axios.delete("customer/deleteCustomer", { params: id });
		return response.data;
	}
}
